// @ts-strict-ignore
import React, { CSSProperties, HTMLAttributes } from 'react'
import { Popover, Button, Typography } from '@mui/material'
import { useTheme, lighten } from '@mui/material/styles'
import { KeyboardArrowLeft } from '@mui/icons-material'
import { useMediaQuery } from 'hooks/useMediaQuery'
import Condition from 'components/Condition'

interface ITutorialBubbleProps extends HTMLAttributes<HTMLDivElement> {
  active?: boolean
  buttonLabel?: string
  message: string
  paperStyle?: CSSProperties
  children?: React.ReactNode
}

function TutorialBubble(props: ITutorialBubbleProps) {
  const { children, message, buttonLabel = 'Got it!', active, paperStyle = {}, ...restProps } = props
  const [open, setOpen] = React.useState(false)
  const containerRef = React.useRef<HTMLDivElement>(null)
  const theme = useTheme()

  const isMatch = useMediaQuery(theme.breakpoints.up(theme.breakpoints.values.md))

  React.useEffect(() => {
    // Popover requires the container ref, which is not available initially.
    setOpen(true)
  }, [])

  return (
    <div ref={containerRef} {...restProps}>
      {children}

      <Condition condition={isMatch}>
        <Popover
          open={open && active}
          onClose={() => setOpen(false)}
          anchorEl={containerRef.current}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            style: {
              transform: 'translateY(-12px)',
              borderTopLeftRadius: 9999,
              borderBottomLeftRadius: 9999,
              color: '#FFF',
              background: lighten(theme.palette.secondary.main, 0.17),
              ...paperStyle,
            },
          }}
        >
          <Typography variant="body1" component="div" style={{ padding: theme.spacing(2) }}>
            <KeyboardArrowLeft style={{ marginRight: theme.spacing(2), verticalAlign: 'middle', marginTop: theme.spacing(-1) }} />

            {message}

            <Button
              onClick={() => setOpen(false)}
              variant="outlined"
              style={{ marginLeft: theme.spacing(2), color: '#FFF', borderColor: '#FFF' }}
              data-cy="tutorial-bubble-close"
            >
              {buttonLabel}
            </Button>
          </Typography>
        </Popover>
      </Condition>
    </div>
  )
}

export default React.memo(TutorialBubble)
